export default "__VITE_ASSET__lkdPzeu9__"